import React from 'react';
import logoDark from '@/images/logo-dark.svg';
import logoLight from '@/images/logo-light.svg';

export const LogoIcon: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = (props) => {
  const isLight = document.body?.classList.contains('theme-mastodon-light') || 
                  (document.body?.classList.contains('theme-system') && window.matchMedia('(prefers-color-scheme: light)').matches);
  const logo = isLight ? logoDark : logoLight;

  return <img src={logo} alt='LaoSocial' {...props} />;
};
